<div class="page-toolbar">
  <div class="page-toolbar__left">
    <div class="search-field">
      <span class="search-field__icon">
        <div class="icon-mask" [style.--icon-url]="'url(assets/icons/search.svg)'"></div>

      </span>
      <input type="text" class="search-field__input" [value]="searchValue" [placeholder]="searchPlaceholder"
        (input)="onSearch($any($event.target).value)" />
    </div>

    <div class="page-toolbar__filters">
      @for (filter of filters; track filter.key) {
      @if (filter.options) {
      <select class="toolbar-filter toolbar-filter--select"
        (change)="onFilterSelect(filter, $any($event.target).value)">
        <option value="">{{ filter.label }}</option>
        @for (option of filter.options; track option) {
        <option [value]="option" [selected]="filter.value === option">
          {{ option }}
        </option>
        }
      </select>
      } @else {
      <button type="button" class="toolbar-filter" (click)="onFilterClick(filter)">
        <span>{{ filter.label }}</span>

        @if (filter.value) {
        <span class="toolbar-filter__value">{{ filter.value }}</span>
        }
      </button>
      }
      }
    </div>
  </div>

  @if (rightText) {
  <div class="page-toolbar__right">
    {{ rightText }}
  </div>
  }
</div>